module.exports = __webpack_public_path__ + "img/selected0-min.65b329f4.png";